export default "__VITE_ASSET__C$eA6MoD__"